import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => (
  <footer className="bg-emerald-950 text-emerald-100/80 mt-auto">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-2.5 mb-4">
          <img src="/logo.png" alt="NovaAgri" className="h-10 w-10 rounded-lg bg-white/10 object-contain p-0.5" />
          <div>
            <div className="font-head font-extrabold text-white">NovaAgri Solution LLP</div>
            <div className="text-[11px] uppercase tracking-widest text-emerald-300/70">Agriculture Technology</div>
          </div>
        </div>
        <p className="text-sm leading-relaxed max-w-xs">
          A private facilitation service helping Indian farmers prepare and apply for agricultural subsidy schemes. Not a government body.
        </p>
      </div>
      <div>
        <h5 className="font-head font-semibold text-white mb-4">Quick Links</h5>
        <div className="flex flex-col gap-2.5 text-sm">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <Link to="/schemes" className="hover:text-white transition-colors">Schemes</Link>
          <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/login" className="hover:text-white transition-colors">Login / Apply</Link>
        </div>
      </div>
      <div>
        <h5 className="font-head font-semibold text-white mb-4">Contact Info</h5>
        <div className="space-y-3.5 text-sm">
          <div className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-emerald-400" /><span>No: 50/33, Chinapanhalli, Marathalli, Bengaluru, Karnataka - 560037</span></div>
          <div className="flex gap-3"><Phone className="h-4 w-4 mt-0.5 shrink-0 text-emerald-400" /><span>+91 87627 65882</span></div>
          <div className="flex gap-3"><Mail className="h-4 w-4 mt-0.5 shrink-0 text-emerald-400" /><span>support@novaagrisolution.com</span></div>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-emerald-200/60">
        © 2026 NovaAgri Solution LLP. All rights reserved.
      </div>
    </div>
  </footer>
);
